import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence';
import { APP_CONFIG_FEATURE_KEY } from './app-config.state';
import { AppConfigEffects } from './effects/app-config.effects';
import { appConfigReducer } from './reducers/app-config.reducer';
import { selectAppConfigValues } from './selectors/app-config.selector';

/**
 * Registers the app-config feature slice. `AppConfigEffects` loads the config from the backend
 * on `loadAppConfig` (dispatched at boot and after a location-tracker save), and mirrors the
 * slice to the generic persistence layer so the location-tracker page's read-only admin values
 * are available offline. `AppConfigService` was never wired up live, so there is no legacy
 * implementation behind an injection token here — the store is the only implementation.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(APP_CONFIG_FEATURE_KEY, appConfigReducer),
        EffectsModule.forFeature([AppConfigEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: APP_CONFIG_FEATURE_KEY,
                persistSelector: selectAppConfigValues,
                localOnly: true,
            },
        },
    ],
})
export class AppConfigStoreModule {}
